#import "../fragments/peep-label-options-fragment.graphql"

query GetPeepLabelOptions {
    peepLabelOptions {
        ...PeepLabelOptionsFragment
    }
}
